import { useMemo } from "react";

import { readState } from "@/__main__/app-state.mjs";
import {
  getCurrentSet,
  setPatches,
  setUnitPrefixes,
  tftSetsDropdown,
} from "@/game-tft/constants.mjs";
import { useRoute } from "@/util/router-hooks.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

/**
 * Gets the set by params
 * @param isLimited - Cap the sets list from all to limited
 * @returns {string}
 */
export default function useSetByParam(isLimited = false, numberOnly = false) {
  const { searchParams } = useRoute();
  const state = useSnapshot(readState);
  const patch = state.tft.latestPatch?.patch;
  const sets = isLimited ? tftSetsDropdown : setUnitPrefixes;
  return useMemo(() => {
    const key = searchParams.get("set");
    const set = `set${key}`;
    if (!numberOnly) {
      if (sets[set]) return set;
      if (patch) return setPatches[patch];
      return getCurrentSet();
    }
    if (sets[set]) return key;
    if (patch) return setPatches[patch]?.replace("set", "");
    return getCurrentSet().replace("set", "");
  }, [searchParams, sets]);
}
